import React from "react";
import { Modal } from "react-bootstrap";
// import { apiBaseUrl, PORT, login_detail, passHeader, auth_response_flow } from '../../Server';
import swal from "sweetalert";
// import { confirm } from "react-confirm-box";
import axios from "axios";
import { CloseIcon, DeleteIcon, EditIcon, PlusIcon } from "../../iconshere";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import NoDataFound1 from "../nodatafound/NoDataFound1";

const options = {
  labels: {
    confirmable: "Confirm",
    cancellable: "Cancel",
  },
};

const Tags = ({ groupId, searchIcon = true, search = "" }) => {
  const [createp, setCreatep] = useState(false);
  const [id, setId] = useState(null);
  const [searchName, setSearchName] = useState("");
  const [createc, setCreatec] = useState(false);
  const [deletep, setDeletep] = useState(false);
  const [deletec, setDeletec] = useState(false);
  const [editp, setEditp] = useState(false);

  const [editc, setEditc] = useState(false);
  const [message, setMessage] = useState("");
  const [list, setList] = useState([]);
  const [parentName, setParentName] = useState("");

  const [child_tag_name, setChildTagName] = useState(null);
  const [child_tag_id, setChildTagId] = useState(null);
  const [deleteCId, setDeleteCId] = useState(null);
  const [deletePCId, setDeletePCId] = useState(null);
  const [parent_id, setParentTagId] = useState(null);
  const [deletePId, setDeletePId] = useState(null);

  useEffect(() => {
    setSearchName(search);
  }, [search]);

  const userData = useSelector((state) => state.userSlice);

  const configData = useSelector((state) => state.configSlice);

  var { apiBaseUrl } = configData.config;

  const { token, user } = userData;

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const editParent = (parent_id, parent_name) => {
    setParentName("");
    setEditp(true);
    setParentTagId(parent_id);
    setParentName(parent_name);
  };

  const createChild = (parent_id) => {
    setChildTagName("");
    setCreatec(true);
    setParentTagId(parent_id);
  };

  const deleteParent = async (event, id) => {
    event.stopPropagation();
    setDeletep(true);
    setDeletePId(id);
  };

  const editChild = (child_tag_id, child_tag_name, parent_id) => {
    console.log(parent_id);
    setChildTagId(child_tag_id);
    setChildTagName(child_tag_name);
    setParentTagId(parent_id);
    setEditc(true);
  };

  const deleteChild = async (c_id, p_id) => {
    console.log(c_id);
    console.log(p_id);
    setDeletec(true);
    setDeleteCId(c_id);
    setDeletePCId(p_id);
  };

  const ParentSubmit = async (e) => {
    e.preventDefault();
    var data = {
      group_uuid: groupId,
      name: parentName.trim(),
    };

    await axios
      .post(`${apiBaseUrl}/api/tags/parenttags`, data, { headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            getParentList();
            setCreatep(false);
            swal(response.data.message);
          }
        }
      })
      .catch(function (err) {

      });
  };

  const getParentList = async () => {
    var data = {
      group_uuid: groupId,
    };
    await axios
      .post(`${apiBaseUrl}/api/tags/gettags`, data, { headers: headers })
      .then(function (response) {
        console.log("", response.data.data);
        if (response.status === 200) {
          if (response.data.error === false) {
            setList(response.data.data);
            setMessage("No Record Found.");
          } else {
            // auth_response_flow(response.data, (return_response) => {
            //     if (return_response.error === false && return_response.retry === true) {
            //         current.getParentList();
            //     }
            // })
          }
        }
      })
      .catch(function (err) {

      });
  };

  const cancelDeleteParent = async (id) => {
    setDeletep(false);
    setDeletePId(null);
  };

  const cancelDeleteChild = async (id) => {
    setDeletec(false);
    setDeleteCId(null);
  };

  const confirmDeletParent = async () => {
    const parent_id = deletePId;
    if (parent_id) {
      await axios
        .delete(`${apiBaseUrl}/api/tags/deleteParent/${parent_id}`, {
          headers: headers,
        })
        .then(function (response) {
          if (response.status === 200) {
            setDeletep(false);
            getParentList();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      return;
    }
  };

  const confirmDeleteChild = async () => {
    console.log("111111111111111111111");
    try {
      const child_id = deleteCId;
      const parent_id = deletePCId;

      if (child_id) {
        const response = await axios.delete(
          `${apiBaseUrl}/api/tags/deleteChild/${child_id}/${parent_id}`,
          {
            headers: headers,
          }
        );
        if (response.status === 200) {
          getParentList();
          setDeletec(false)
          console.log("Child tag deleted successfully");
        }
      }
    } catch (error) {
      console.error("Error deleting child tag:", error);
    }
  };

  const onParentUpdate = async (e) => {
    var data = {
      group_uuid: groupId,
      parent_tag_id: parent_id,
      parentName: parentName,
    };

    await axios
      .post(`${apiBaseUrl}/api/tags/updateParentTags`, data, { headers: headers })
      .then(function (response) {
        console.log(response);
        if (response.status === 200) {
          if (response.data.error === false) {
            setEditp(false);
            swal(response.data.message);
            getParentList();
          } else {
          }
        }
      })
      .catch(function (err) {
        console.log(err);

      });
  };

  const onChildSubmit = async (e) => {
    e.preventDefault();

    var data = {
      parent_tag_id: parent_id,
      child_tag_name: child_tag_name,
    };
    await axios
      .post(`${apiBaseUrl}/api/tags/childtags`, data, { headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            getParentList();
            setCreatec(false);
            swal(response.data.message);
          } else {
            swal(response.data.message);
          }
        }
      })
      .catch(function (err) {
        console.log(err);

      });
  };

  const onChildUpdate = async (e) => {
    e.preventDefault();
    var data = {
      parent_id: parent_id,
      child_tag_id: child_tag_id,
      child_tag_name: child_tag_name,
    };

    console.log(data);

    await axios
      .patch(`${apiBaseUrl}/api/tags/childtags`, data, { headers: headers })
      .then(function (response) {
        console.log(response);
        if (response.status === 200) {
          if (response.data.error === false) {
            getParentList();
            setEditc(false);
            swal(response.data.message);
          } else {
            swal(response.data.message);
          }
        }
      })
      .catch(function (err) {

      });
  };

  useEffect(() => {
    getParentList();
  }, [groupId]);

  return (
    <>
      <div className="page-content pt-3">
        <div className="container-fluid">
          <div className="row corpheader">
            <div className="col-md-6">
              <form className=" app-search app-search1 d-flex justify-content-start">
                <div className="position-relative">
                  {searchIcon ? (
                    <>
                      <span className="bx bx-search-alt"></span>
                      <input
                        type="text"
                        name="searchName"
                        className="form-control"
                        value={searchName}
                        onChange={(e) => setSearchName(e.target.value.replace(/\s+/g, " "))}
                        placeholder="Search Tags"
                        autocomplete="off"
                      />
                    </>
                  ) : null}
                </div>
              </form>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <div className="text-md-right">
                <button
                  className="redbtn"
                  onClick={() => {
                    setCreatep(true);
                    setParentName("");
                  }}>
                  <PlusIcon />
                  Create Parent
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <div className="panelliststart">
                  {list.length > 0 ? list.filter((e) => !searchName.length || e.name.toLowerCase().includes(searchName.toLowerCase)).map((item, index) => {
                    return (
                      <details close>
                        <summary>
                          {item.name}
                          <span>
                            <span style={{ display: "flex", gap: "15px", alignItems: "center" }}>
                              <button
                                style={{ marginLeft: "10px" }}
                                onClick={() => createChild(item._id)}
                                className="btn redbgbtn btn-sm font-weight-500">
                                Add
                              </button>
                              <div
                                className="svgbtn"
                                onClick={() => editParent(item._id, item.name)}>
                                <EditIcon />
                              </div>
                              <div className="svgbtn" onClick={(e) => deleteParent(e, item._id)}>
                                <DeleteIcon />
                              </div>
                            </span>
                          </span>
                        </summary>
                        <div className="paneldetail">
                          <div>
                            <table className="table table-bordered">
                              {item["child_tags"].length === 0 ? (
                                !message.length ? (
                                  <div className="lds-spinner">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                ) : (
                                  // <div className="message-no-record"> {message} </div>
                                  <NoDataFound1 heading="No Record Found" />
                                )
                              ) : null}

                              {item["child_tags"].map((list1, index1) => (
                                <tbody>
                                  <tr>
                                    <td
                                      className="align-middle"
                                      style={{ fontWeight: "500", paddingLeft: "15px" }}>
                                      {list1.name}
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        gap: "15px",
                                        alignItems: "center",
                                        justifyContent: "end",
                                      }}>
                                      <div
                                        className="svgbtn"
                                        onClick={() =>
                                          editChild(list1._id, list1.name, item._id)
                                        }>
                                        <EditIcon />
                                      </div>
                                      <div
                                        className="svgbtn"
                                        onClick={() => deleteChild(list1._id, item._id)}>
                                        <DeleteIcon />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              ))}
                            </table>
                          </div>
                        </div>
                      </details>
                    );
                  })
                    :
                    <NoDataFound1 heading="No Record Found" />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Create Parent */}
      <Modal centered show={createp} onHide={() => setCreatep(false)}>
        <Modal.Header className="popupheader">
          Create Parent
          <div style={{ cursor: "pointer" }} onClick={() => setCreatep(false)}>
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <p className="popupheading">Parent Name</p>
                <input
                  type="text"
                  className="form-control"
                  name="parentName"
                  value={parentName}
                  onChange={(e) => setParentName(e.target.value.replace(/\s+/g, " "))}
                />
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-end mt-2 mb-2">
                  <button className="redbgbtn" onClick={ParentSubmit}>
                    Create
                  </button>
                  {/* <Button style={{marginLeft:'10px'}} className="btn btn-secondary" variant="secondary" onClick={this.closeParent}>Cancel </Button>            */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Parent */}
      <Modal centered show={editp} onHide={() => setEditp(false)}>
        <Modal.Header className="popupheader">
          Edit Parent
          <div style={{ cursor: "pointer" }} onClick={() => setEditp(false)}>
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <p className="popupheading">Parent Name</p>
                <input
                  type="text"
                  className="form-control"
                  name="parentName"
                  value={parentName}
                  onChange={(e) => setParentName(e.target.value)}
                />
                <input
                  type="text"
                  className="form-control"
                  name="parent_tag_id"
                  value={""}
                  hidden
                />
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-end mt-2 mb-2">
                  <button className="redbgbtn" onClick={onParentUpdate}>
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Create Child */}
      <Modal centered show={createc} onHide={() => setCreatec(false)}>
        <Modal.Header className="popupheader">
          Create Child
          <div style={{ cursor: "pointer" }} onClick={() => setCreatec(false)}>
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <p className="popupheading">Child Name</p>
                <input
                  type="text"
                  className="form-control"
                  name="child_tag_name"
                  value={child_tag_name}
                  onChange={(e) => setChildTagName(e.target.value.replace(/\s+/g, " "))}
                />
                <input type="text" className="form-control" name="parent_id" value={id} hidden />
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-end mt-2 mb-2">
                  <button className="redbgbtn" onClick={onChildSubmit}>
                    Create
                  </button>
                  {/* <Button style={{marginLeft:'10px'}} className="btn btn-secondary" variant="secondary" onClick={this.closeChild}>Cancel </Button>            */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Child */}
      <Modal centered show={editc} onHide={() => setEditc(false)}>
        <Modal.Header className="popupheader">
          Edit Child
          <div style={{ cursor: "pointer" }} onClick={() => setEditc(false)}>
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <p className="popupheading">Child Name</p>
                <input
                  type="text"
                  className="form-control"
                  name="child_tag_name"
                  value={child_tag_name}
                  onChange={(e) => setChildTagName(e.target.value.replace(/\s+/g, " "))}
                />
                <input
                  type="text"
                  className="form-control"
                  name="child_tag_id"
                  value={child_tag_id}
                  hidden
                />
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-end mt-2 mb-2">
                  <button className="redbgbtn" onClick={onChildUpdate}>
                    Update
                  </button>
                  {/* <Button style={{marginLeft:'10px'}} className="btn btn-secondary" variant="secondary" onClick={this.closeEditChild}>Cancel </Button>            */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete Parent */}
      <Modal centered show={deletep} onHide={() => setDeletep(false)}>
        <Modal.Header className="popupheader delete pt-4">
          Delete Parent
          {/* <div style={{ cursor:"pointer" }} onClick={this.cancelDeleteChild} ><CloseIcon/></div> */}
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group pt-4 pb-5 m-0">
                <p className="popupheading delete p-0 m-0">
                  Do you really want to delete this parent?
                </p>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center mt-2 mb-2">
                  <button className="redbgbtn cancel" onClick={cancelDeleteParent}>
                    Cancel
                  </button>
                  <button className=" ms-3  redbgbtn" onClick={confirmDeletParent}>
                    Delete
                  </button>
                  {/* <Button style={{marginLeft:'10px'}} className="btn btn-secondary" variant="secondary" onClick={this.closeParent}>Cancel </Button>            */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete Child */}
      <Modal centered show={deletec} onHide={cancelDeleteChild}>
        <Modal.Header className="popupheader delete pt-4">
          Delete Child
          {/* <div style={{ cursor:"pointer" }} onClick={this.cancelDeleteChild} ><CloseIcon/></div> */}
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group pt-4 pb-5 m-0">
                <p className="popupheading delete p-0 m-0">
                  Do you really want to delete this child?
                </p>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center mt-2 mb-2">
                  <button className=" redbgbtn cancel" onClick={cancelDeleteChild}>
                    Cancel
                  </button>
                  <button className="ms-3 redbgbtn" onClick={confirmDeleteChild}>
                    Delete
                  </button>
                  {/* <Button style={{marginLeft:'10px'}} className="btn btn-secondary" variant="secondary" onClick={this.closeParent}>Cancel </Button>            */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tags;
